import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, waLink, WHATSAPP_GENERIC } from "@/data/content";

export default function DesignCTA() {
  return (
    <section className="bg-navy" data-testid="design-cta">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
        <div className="max-w-2xl">
          <Reveal>
            <h2 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.02]">
              Have a design? Send it to us.
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-4 text-base text-slate-300 leading-relaxed">
              Already have a design, logo or team concept? Send it to our team and let's
              discuss your requirements.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href={waLink(WHATSAPP_GENERIC)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="design-cta-whatsapp"
                className="btn-accent"
              >
                <MessageCircle size={17} />
                Send your design on WhatsApp
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="design-cta-email"
                className="btn-outline"
              >
                <Mail size={17} />
                Email your design
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              href={CONTACT.phoneTel}
              data-testid="design-cta-phone"
              className="mt-6 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
            >
              {CONTACT.phoneDisplay}
              <ArrowUpRight size={14} className="text-ice" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
